import { useCallback, useMemo } from 'react';

import { useCareerSkillsSearchLazyQuery } from 'core';

export interface ICareerSkillOption {
  id: string;
  name: string;
  /** Слаг справочника: нужен, чтобы у добавленного навыка сразу был значок. */
  slug: string;
  iconUrl: string | null;
  category: string;
}

type CareerSkillsSearch = [
  (search: string, category?: string) => void,
  {
    options: ICareerSkillOption[];
    loading: boolean;
  },
];

/**
 * Dictionary autocomplete for the skills + project-technologies pickers
 * (spec 0018, increment B). `no-cache` so each keystroke query returns the
 * server's latest matches rather than a stale merged set.
 */
export const useCareerSkillsSearch = (): CareerSkillsSearch => {
  const [run, { data, loading }] = useCareerSkillsSearchLazyQuery({ fetchPolicy: 'no-cache' });

  const search = useCallback(
    (searchTerm: string, category?: string) => run({ variables: { search: searchTerm, category } }),
    [run],
  );

  const options = useMemo<ICareerSkillOption[]>(
    () =>
      (data?.careerSkills ?? []).map((row) => ({
        id: row.id,
        name: row.name,
        slug: row.slug,
        iconUrl: row.iconUrl ?? null,
        category: row.category,
      })),
    [data],
  );

  return [search, { options, loading }];
};
